module.exports = __webpack_public_path__ + "assets/img/8_1595.d778bac9.jpg";